import { getTagsFromApi, getTagsFromCms } from 'application/adapters/cms/tagsAdapter';

export interface TagsQuery {
	rootId?: number;
}

export const getTags = async (query: TagsQuery): Promise<Tags.Tag[]> => {
	if (typeof window === 'undefined') {
		//Server side
		return await getTagsFromCms(query.rootId);
	} else {
		//Client side
		return await getTagsFromApi(query.rootId);
	}
};
